import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.css';
import getFirestoreApp from './firebase/firebase'

getFirestoreApp()

ReactDOM.render(<App />,document.getElementById('root')
);




